var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResAmazonEc2Instances48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Resource/Compute/Res_Amazon-EC2_Instances_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Resource/Compute/Res_Amazon-EC2_Instances_48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.131,22.96 L9.986,22.96 L9.986,24.96 L4.131,24.96 C2.956,24.96 2,24.004 2,22.829 L2,4.131 C2,2.956 2.956,2 4.131,2 L22.829,2 C24.004,2 24.96,2.956 24.96,4.131 L24.96,10.86 L22.96,10.86 L22.96,4.131 C22.96,4.059 22.902,4 22.829,4 L4.131,4 C4.059,4 4,4.059 4,4.131 L4,22.829 C4,22.901 4.059,22.96 4.131,22.96 L4.131,22.96 Z M13.737,33.44 L21.279,33.44 L21.279,35.44 L13.737,35.44 C12.563,35.44 11.607,34.484 11.607,33.31 L11.607,14.61 C11.607,13.436 12.563,12.48 13.737,12.48 L32.436,12.48 C33.61,12.48 34.567,13.436 34.567,14.61 L34.567,21.34 L32.567,21.34 L32.567,14.61 C32.567,14.538 32.508,14.48 32.436,14.48 L13.737,14.48 C13.665,14.48 13.607,14.538 13.607,14.61 L13.607,33.31 C13.607,33.382 13.665,33.44 13.737,33.44 L13.737,33.44 Z M43.85,43.92 L24.96,43.85 L24.96,25.091 C24.96,25.019 25.019,24.96 25.091,24.96 L43.789,24.96 C43.861,24.96 43.92,25.019 43.92,25.091 L43.85,43.92 Z M43.789,22.96 L25.091,22.96 C23.916,22.96 22.96,23.916 22.96,25.091 L22.96,43.85 C22.96,44.991 23.889,45.92 25.03,45.92 L43.85,45.92 C44.991,45.92 45.92,44.991 45.92,43.85 L45.92,25.091 C45.92,23.916 44.964,22.96 43.789,22.96 L43.789,22.96 Z",
    id: "Amazon-EC2-Instances_Resource-Icon_light-bg",
    fill: "#ED7100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResAmazonEc2Instances48);
export default __webpack_public_path__ + "static/media/Res_Amazon-EC2_Instances_48.63d2b54fbc85a0dbcbe320868bfb4e15.svg";
export { ForwardRef as ReactComponent };